<template>
  <div id="ticket">
    <div class="ticket_detail_header" slot="header">
      <h4>{{ $t('supportTickets.viewingTicket') }}: {{ data.id }}</h4>
    </div>
    <div class="ticket_detail_body">
      <div class="subject">
        <h5>{{ $t('supportTickets.status') }}</h5>
        <p class="info_description">{{ $t('supportTickets.tabStatus.' + data.status) }}</p>
      </div>
      <div class="subject">
        <h5>{{ $t('supportTickets.subject') }}</h5>
        <p class="info_description">{{ data.subject }}</p>
      </div>
      <ul class="comment_list" v-if="commentList.length > 0">
        <li class="comment_list_item" v-for="item in commentList" :key="item.id">
          <div class="comment_info">
            <h5 class="author">{{ item.authorName }}</h5>
            <!-- <span>{{ item.createdAtDisplay }}</span> -->
          </div>
          <div class="comment_content">
            <div class="user_comment">{{ sanitizeContent(item.body) }}</div>
            <div class="attachment" v-if="item.attachments && item.attachments.length > 0">
              <!-- <span class="attachment_text">{{ $t('supportTickets.attachments') }}: </span> -->
              <div class="attachment_list">
                <a
                  :href="attachment.mapped_content_url"
                  target="_blank"
                  v-for="attachment in item.attachments"
                  :key="attachment.id"
                  class="attachment_item"
                >
                  <span class="icon" :class="getIconType(attachment.content_type)"></span>
                  <span class="file_name"
                    >{{ attachment.file_name.split('.')[0] }}.<span class="file_name file_type">{{
                      attachment.file_name.split('.').pop()
                    }}</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="ticket_detail_footer" slot="footer">
      <div class="footer_button" v-if="data.status === 'closed'">
        <el-button @click="onClose()">{{ $t('supportTickets.close') }}</el-button>
        <el-button @click="onCreateNewTicket()" class="blue_button">{{
          $t('supportTickets.createNewTicket')
        }}</el-button>
      </div>
      <div v-else>
        <div v-if="data.status === 'new' || data.status === 'pending' || data.status === 'open'">
          <h5 class="post_reply">{{ $t('supportTickets.postReply') }}</h5>
          <CommentSection
            ref="commentSection"
            :fileList.sync="uploadFileList"
            :editorData.sync="editorContent"
            :enableCharsLimit="true"
          />
        </div>
        <div class="footer_button">
          <el-button @click="onClose()" class="white_button">{{ $t('supportTickets.close') }}</el-button>
          <el-button
            v-if="data.status === 'new' || data.status === 'pending' || data.status === 'open'"
            @click="onSubmit('update')"
            class="blue_button"
            >{{ $t('supportTickets.update') }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiTicketComment } from '@/resource';
import CommentSection from '@/components/support/CommentSection';
import ticketMixin from '@/mixins/ticket';
import DOMPurify from 'dompurify';

const editorContentDefault = {
  html: '',
  text: '',
  quill: {}
};
export default {
  name: 'Ticket',
  components: { CommentSection },
  mixins: [ticketMixin],
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    ticketDialog: Boolean
  },
  data() {
    return {
      commentList: [],
      uploadFileList: [],
      editorContent: { ...editorContentDefault }
    };
  },
  mounted() {
    if (this.data.id) {
      this.fetchComments();
    }
  },
  methods: {
    fetchComments() {
      apiTicketComment(this.data.id).then(resp => {
        if (resp.data.code === 0) {
          this.commentList = resp.data.data.comments;
        }
      });
    },
    getIconType(fileType) {
      if (fileType.includes('image')) {
        return 'el-icon-picture-outline';
      }
      return 'el-icon-document';
    },
    onCreateNewTicket() {
      this.$emit('createNewTicket');
      this.resetInputField();
    },
    sanitizeContent(values) {
      return DOMPurify.sanitize(values);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/components/support/ticket.scss';
</style>
